import React from 'react'

const BannerLanding = (props) => (
    <section id="banner" className="style2">
        <div className="inner">
            <header className="major">
                <h1>Resume</h1>
            </header>
            <div className="content">
                <p>PWA AND SPA BY REACT.JS<br />
FULL-STACK DEVELOPMENT OF WORDPRESS SITE (PLANNNING,DIRECTION,SETUP AWS)
</p>
            </div>
        </div>
    </section>
)

export default BannerLanding
